import { watchRedirect } from './redirect';
import { watchTakePhoto, watchUploadPhoto } from './photo';
import { watchExamination } from './examination';
import { watchResultHistory, watchResultHistoryList } from './result-history';
import {
  watchVerificationCode, watchRegistration,
  watchUserLogin, watchUpdateUserInfo, watchResetPassword, watchChangePassword,
  watchRefreshUserInfo, watchLogout, watchSyncAvatar,
} from './user';

export function runSagas(sagaMiddleware) {
  sagaMiddleware.run(watchRedirect);
  sagaMiddleware.run(watchTakePhoto);
  sagaMiddleware.run(watchUploadPhoto);
  sagaMiddleware.run(watchExamination);
  sagaMiddleware.run(watchResultHistory);
  sagaMiddleware.run(watchResultHistoryList);
  sagaMiddleware.run(watchRegistration);
  sagaMiddleware.run(watchVerificationCode);
  sagaMiddleware.run(watchUserLogin);
  sagaMiddleware.run(watchUpdateUserInfo);
  sagaMiddleware.run(watchSyncAvatar);
  sagaMiddleware.run(watchResetPassword);
  sagaMiddleware.run(watchChangePassword);
  sagaMiddleware.run(watchRefreshUserInfo);
  sagaMiddleware.run(watchLogout);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js